import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
// import _filter from "lodash/filter";
import _find from "lodash/find";
import { useTranslation } from "react-i18next";
// import _findIdx from "lodash/findIndex";

import avatar from "../../img/nophoto.jpg";

const GameList = ({ games, ...props }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container mx-auto">
        <div className="py-8">
          <div className="shadow rounded-lg">
            <table className="min-w-full leading-normal">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    {t("order_num")}
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    {t("game_type")}
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    {t("status")}
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    {t("players")}
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    {t("winner")}
                  </th>
                  <th
                    scope="col-span-2"
                    className="px-5 py-3 bg-white border-b border-t border-gray-200 text-black text-left text-sm uppercase font-bold"
                  >
                    {t("created_at")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {games.map((item, idx) => {
                  let type = item.status;

                  let winner = null;
                  if (type === "IN_PROGRESS") {
                    type = t("in_progress_lowercase");
                  } else if (type === "LOBBY") {
                    type = t("in_lobby");
                  } else {
                    type = t("finished");
                  }
                  winner = _find(item.users, function (o) {
                    return o.id === item.winnerId;
                  });
                  return (
                    <tr {...props}>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {idx + 1}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.type === "PRIVATE"
                            ? t("closed_session")
                            : t("open_session")
                          }
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {type}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.users.map((user) => {
                            return (
                              <>
                                <p className="text-gray-900 whitespace-no-wrap">
                                  {user.firstName} {user.lastName}
                                </p>
                              </>
                            );
                          })}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {winner && winner.firstName + " " + winner.lastName}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {moment(item.updated_at).format("DD.MM.YYYY-hh:mm")}
                        </p>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameList;
